
let confirmHandlerAttached = false;
export default function initConfirmButtons() {
  if (confirmHandlerAttached) return;
  confirmHandlerAttached = true;

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-confirm]');
    if (!trigger) return;

    const confirmMessage = trigger.getAttribute('data-confirm');
    if (confirmMessage && !window.confirm(confirmMessage)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
  });
}
